<template>
  <svg
      :width="width"
      xmlns="http://www.w3.org/2000/svg"
      :fill="color"
      viewBox="0 0 80 80" x="0px" y="0px"
  >
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M48.9999 8C50.6568 8 52 9.33408 51.9999 10.991C51.9998 17.2646 51.9995 32.5499 51.9994 48.581C51.9994 49.1333 52.4471 49.5815 52.9994 49.5815H57C57.5523 49.5815 58 49.1338 58 48.5815V22.8774C58 22.714 57.8676 22.5815 57.7042 22.5815C57.0783 22.5815 56.6062 22.0131 56.7212 21.3979L58.0964 14.0367C58.4518 12.1342 59.7032 10.5199 61.4571 9.70145L64.9011 8.09434C65.4709 7.82848 66.1417 8.14807 66.2941 8.75799L67.3055 12.8033C67.4192 13.258 67.2018 13.7307 66.7825 13.9403L66.1452 14.259C64.4775 15.0928 63.2923 16.6545 62.9379 18.4849L62.3014 21.7716C62.2104 22.2419 61.7987 22.5815 61.3197 22.5815C61.1431 22.5815 61 22.7247 61 22.9012V50.5815L61 51.5816C61 52.1338 60.5523 52.5815 60 52.5815H52.9993C52.4471 52.5815 51.9993 53.0293 51.9993 53.5815L51.9993 59.0014C51.9993 60.6583 50.6562 62 48.9993 62H21C19.3431 62 18 60.6569 18 59V11C18 9.34315 19.3431 8 21 8H48.9999ZM15.0398 64H54.9608C56.087 64 57 64.955 57 66.1336V71.4669C57 71.7602 56.7714 72 56.4904 72H13.5103C13.2286 72 13 71.7602 13 71.4669V66.1336C13 64.955 13.913 64 15.0398 64ZM30.438 31.0823C30.1814 31.1597 29.9711 30.8327 30.0954 30.5483L36.0885 20.6926C36.2091 20.4133 36.3556 20.1425 36.5879 20.0395C36.6517 20.0112 36.7228 20.0071 36.7926 20.0071L43.4717 20.0071C43.5422 20.0071 43.6134 19.9932 43.6833 20.0027C43.9399 20.0374 44.0966 20.4055 43.9332 20.6843L38.0965 29.3246C37.5619 30.1161 38.335 31.135 39.2412 30.8332L39.9522 30.5963C40.1674 30.5228 40.3204 30.8517 40.1562 31.0394L28.2993 43.94C28.1543 44.1045 27.9312 43.9013 28.0204 43.6865L33.0078 31.8857C33.3541 31.0662 32.5383 30.2365 31.7131 30.5688L30.438 31.0823Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>
